import { defineComponent, PropType, reactive, computed, getCurrentInstance, createApp, onMounted, nextTick, ref, provide, inject, watchEffect, watch } from 'vue'
import './scale-rect.css'
import UEI from '../use/useEditInfo'
import { initCustomFormatter } from 'vue'

export const ScaleRect = defineComponent({
  name: 'scale-rect',
  setup() {
    const state = reactive({
      top_left: '',
      top_right: '',
      bottom_left: '',
      bottom_right: '',
      center_left: '',
      center_right: '',
      center_top: '',
      center_bottom: '',
      // 线条样式
      line_x_top: '',
      line_x_bottom: '',
      line_y_left: '',
      line_y_right: ''
    })

    onMounted(() => {
      const containerBox = document.getElementById('comp-canves-wrap') || undefined
      containerBox && containerBox.addEventListener('scroll', UEI.setDotrectInfo)
      window.addEventListener('resize', function () {
        UEI.setDotrectInfo()
      })
    })

    function clearDot() {
      state.top_left = ''
      state.top_right = ''
      state.bottom_left = ''
      state.bottom_right = ''
      state.center_left = ''
      state.center_right = ''
      state.center_top = ''
      state.center_bottom = ''
    }

    function changeDot() {
      clearDot()
      if (!UEI.state.dotrectInfo || !UEI.state.clickLayout || !UEI.state.clickLayout.styleConfig) return
      const keys = Object.keys(UEI.state.clickLayout.styleConfig)
      const _info = UEI.state.dotrectInfo
      const _config = UEI.state.clickLayout.styleConfig
      if (keys.includes('width') && keys.includes('height') && parseFloat((_config as any).width) == (_config as any).width && parseFloat((_config as any).height) == (_config as any).height) {
        state.top_left = `top:${_info.top - 6}px;left:${_info.left - 7}px;`
        state.top_right = `top:${_info.top - 6}px;left:${_info.left + _info.width + 1}px;`
        state.bottom_left = `top:${_info.top + _info.height + 0}px;left:${_info.left - 7}px;`
        state.bottom_right = `top:${_info.top + _info.height + 0}px;left:${_info.left + _info.width + 1}px;`
      }
      if (keys.includes('width') && parseFloat((_config as any).width) == (_config as any).width) {
        state.center_left = `top:${_info.top + _info.height / 2 - 3}px;left:${_info.left - 7}px;`
        state.center_right = `top:${_info.top + _info.height / 2 - 3}px;left:${_info.left + _info.width + 1}px;`
      }
      if (keys.includes('height') && parseFloat((_config as any).height) == (_config as any).height) {
        state.center_top = `top:${_info.top - 6}px;left:${_info.left + _info.width / 2 - 2}px;`
        state.center_bottom = `top:${_info.top + _info.height + 0}px;left:${_info.left + _info.width / 2 - 2}px;`
      }
      state.line_x_top = `width:${_info.width + 9}px;left:${_info.left - 5}px;top:${_info.top - 5}px`
      state.line_x_bottom = `width:${_info.width + 9}px;left:${_info.left - 5}px;top:${_info.top + _info.height + 4}px`
      state.line_y_left = `height:${_info.height + 9}px;left:${_info.left - 5}px;top:${_info.top - 5}px`
      state.line_y_right = `height:${_info.height + 9}px;left:${_info.left + _info.width + 4}px;top:${_info.top - 5}px`
    }

    watch(
      () => UEI.state.clickLayout,
      () => {
        nextTick(() => {
          UEI.setDotrectInfo()
          nextTick(() => {
            changeDot()
          })
        })
      },
      { deep: true }
    )

    watchEffect(() => {
      changeDot()
    })

    return () => {
      return (
        <div class="scale-rect">
          {UEI.state.clickLayout && !UEI.state.clickLayout.isroot && UEI.clickElement ? (
            <>
              {state.top_left ? <div class="scale-rect-dot dot-top-left" style={state.top_left}></div> : null}
              {state.top_right ? <div class="scale-rect-dot dot-top-right" style={state.top_right}></div> : null}
              {state.bottom_left ? <div class="scale-rect-dot dot-bottom-left" style={state.bottom_left}></div> : null}
              {state.bottom_right ? <div class="scale-rect-dot dot-bottom-right" style={state.bottom_right}></div> : null}
              {state.center_left ? <div class="scale-rect-dot dot-center-left" style={state.center_left}></div> : null}
              {state.center_right ? <div class="scale-rect-dot dot-center-right" style={state.center_right}></div> : null}
              {state.center_top ? <div class="scale-rect-dot dot-center-top" style={state.center_top}></div> : null}
              {state.center_bottom ? <div class="scale-rect-dot dot-center-bottom" style={state.center_bottom}></div> : null}
              {/* 下面是四周线条 */}
              <div class="scale-rect-line scale-rect-line-x" style={state.line_x_top}></div>
              <div class="scale-rect-line scale-rect-line-x" style={state.line_x_bottom}></div>
              <div class="scale-rect-line scale-rect-line-y" style={state.line_y_left}></div>
              <div class="scale-rect-line scale-rect-line-y" style={state.line_y_right}></div>
            </>
          ) : null}
        </div>
      )
    }
  }
})
